import React, { useContext } from "react";
import axios from "axios";

const apiClient = axios.create({
  // baseURL: process.env.REACT_APP_API_ENDPOINT,
  // withCredentials: true,
});

const AppContext = React.createContext();
const initialUserState = {
  id: "",
  username: "",
  fullName: "",
  entry: [],
  admin: false,
  idNumber: "",
};

const AppProvider = ({ children }) => {
  const [user, setUser] = React.useState(initialUserState);
  const login = async (identifier, password, admin) => {
    try {
      let userData, jwt;
      if (admin) {
        const res = await apiClient.post("/admin/login", {
          email: identifier,
          password,
        });
        userData = res.data.data.user;
        userData.admin = true;
        jwt = res.data.data.token;
      } else {
        const res = await apiClient.post("/auth/local", {
          identifier,
          password,
        });
        userData = res.data.user;
        userData.admin = false;
        jwt = res.data.jwt;
      }
      setUser({
        id: userData.id,
        username: userData.username,
        fullName: userData.fullName,
        admin: userData.admin,
        idNumber: userData.idNumber,
        entries: userData.entries
          ? userData.entries.map((e) => ({
              id: e.id,
              exam: e.exam?.id,
              examName: e.exam?.name,
              grade: e.grade,
              status: e.status,
              registrationDate: e.registrationDate,
              startedAt: e.startedAt,
              startDate: e.startDate,
            }))
          : [],
      });
      sessionStorage.setItem("token", jwt);
      apiClient.defaults.headers.common["Authorization"] = `Bearer ${jwt}`;
    } catch (error) {
      console.error(error.response.data);
      throw new Error(JSON.stringify(error.response));
    }
  };
  const logout = async () => {
    setUser(initialUserState);
    apiClient.defaults.headers.common["Authorization"] = "";
    sessionStorage.removeItem("token");
  };
  const me = async () => {
    const jwt = sessionStorage.getItem("token");
    if (jwt) {
      apiClient.defaults.headers.common["Authorization"] = `Bearer ${jwt}`;
      try {
        const res = await apiClient.get("/users/me");
        const userData = res.data;
        if (
          userData.roles &&
          userData.roles[0] &&
          userData.roles[0].code === "strapi-super-admin"
        ) {
          userData.admin = true;
        } else {
          userData.admin = false;
        }
        setUser({
          id: userData.id,
          username: userData.username,
          fullName: userData.fullName,
          entries: userData.entries
            ? userData.entries.map((e) => ({
                id: e.id,
                exam: e.exam?.id,
                examName: e.exam?.name,
                grade: e.grade,
                status: e.status,
                registrationDate: e.registrationDate,
                startedAt: e.startedAt,
                startDate: e.startDate,
              }))
            : [],
          admin: userData.admin,
          idNumber: userData.idNumber,
        });
      } catch (error) {
        apiClient.defaults.headers.common["Authorization"] = "";
        setUser(initialUserState);
        alert(error);
        console.error(error.response.data);
      }
    }
  };

  const identification = async (idNumber) => {
    try {
      const res = await apiClient.put("/exams/identification", {
        idNumber,
      });
      setUser({ ...user, idNumber: res.data });
    } catch (error) {
      console.error(error.response.data);
      throw new Error(JSON.stringify(error.response));
    }
  };

  React.useLayoutEffect(() => {
    me();
  }, []);

  return (
    <AppContext.Provider
      value={{ apiClient, user, login, logout, me, identification }}
    >
      {children}
    </AppContext.Provider>
  );
};
// make sure use
export const useGlobalContext = () => {
  return useContext(AppContext);
};

export { AppContext, AppProvider };
